// extracted by mini-css-extract-plugin
export var firstGlow = "styles-module--first-glow--04f94";
export var mainContent = "styles-module--main-content--2666e";
export var secondGlow = "styles-module--second-glow--8b0d7";
export var subtitle = "styles-module--subtitle--33f52";
export var suptitle = "styles-module--suptitle--412fd";
export var title = "styles-module--title--2f729";